jQuery(function($){
  $('.material-content .color-swatch input').on('change', function(e){
    let templateName = $(this).attr('name'),    
        index = $(this).data('index');
    	parentSection = $(this).closest('.shopify-section'),
        images = parentSection.find('.material-images .image'),
        contentBlocks = parentSection.find('.material-content .content-block');
    
    images.hide();
    contentBlocks.hide();
    parentSection.find('.image-' + templateName + '-' + index).show();
    parentSection.find('.content-block-' + templateName+ '-' + index).show();
  })

  $('#product-checkbox').on('change', function(){
    if(this.checked){
      $("#product-modal").modal({
        escapeClose: false,
        clickClose: false,
        showClose: false,
        fadeDuration: 150
      });
      $('.buttons-holder button').attr('disabled', false);
    }else{  
      $('.buttons-holder button').attr('disabled', true);
    }
  })

  // if(!localStorage.getItem('hide-campaign')){
  //   $('#campaign-modal').modal({
  //       escapeClose: false,
  //       clickClose: false,
  //       showClose: true,
  //       fadeDuration: 150,
  //       blockerClass: "jquery-modal cm-blocker"
  //   })
  // }

  // $('#campaign-modal').on($.modal.CLOSE, function(event, modal) {
  //   localStorage.setItem('hide-campaign', true);
  // });

  if($('.compare-price.product__price--compare').text().length == 0){
    $('.compare-price.product__price--compare').hide();
  }

  $('.css-slider-container .product-item').attr('draggable', false);
  $('.css-slider-container .product-item').addClass('disable-select');
})